import { cronosClient } from "@/config/client"

export enum UserRole {
  STUDENT = "student",
  SUPERVISOR = "supervisor",
}

export enum UserSex {
  F = "F",
  M = "M",
  X = "X",
}

export type ProductTourStatus = "completed" | "skipped" | null

export interface GetUserInfo {
  id: string
  firstName: string
  lastName: string
  universityId: string
  externalId: string
  userRole: UserRole
  dailyStudyHours: number
  profilePicUrl: string
  emailAddress: string
  sex: UserSex
  timeZone: string
  wasOnboarded: boolean
  productTour: ProductTourStatus
}

interface GetUserInfoResponse {
  description: {
    user: GetUserInfo
  }
}

export function get(token: string) {
  return cronosClient
    .setDefaultHeader("Authorization", `Bearer ${token}`)
    .get<GetUserInfoResponse>("/v1/user/info")
}
